/* Svensk katalog for locale-onboarding-setup-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'onb.companyFormRequired': 'Ange bolagsformen från företagets registrering.',
  'home.incompleteBasisTitle': 'Redovisningsunderlaget är ofullständigt',
  'home.incompleteBasisText': 'Översikten visas inte som komplett eftersom journaltäckningen eller nödvändigt ingående underlag inte är dokumenterat. Tillgängliga data finns kvar för kontroll.',
  'common.doLater': 'Gör senare',
  'onb.restMode.required': 'Välj om bolaget ska ansöka om viloläge eller använda vanlig lösning.',
  'onb.task.restMode.title': 'Slutför inställningen av bolag i viloläge',
  'onb.task.restMode.detail': 'Anslut alla bankkonton, kontrollera ingående balans och ge nödvändiga fullmakter innan automatiken kan starta.',
  'onb.task.restMode.activityDetail': 'Automatiken har stoppats eftersom Plumme har hittat aktivitet som måste kontrolleras. Räntor och vanliga bankavgifter stoppar inte viloläget.',
  'onb.task.restMode.qualificationActivityDetail': 'Kvalificeringen är pausad eftersom Plumme har registrerat aktivitet som måste bedömas. Automatiken är fortfarande pausad. Makulering tar inte bort kontrollspåret.',
  'onb.task.restMode.finding.sales_activity': 'Försäljning är registrerad.',
  'onb.task.restMode.finding.purchase_activity': 'Inköp eller verifikationer är registrerade.',
  'onb.task.restMode.finding.payroll_activity': 'Anställda eller löneaktivitet är registrerad.',
  'onb.task.restMode.finding.fixed_asset_activity': 'Anläggningstillgångar är registrerade.',
  'onb.task.restMode.finding.investment_activity': 'Investeringar är registrerade.',
  'onb.task.restMode.finding.manual_accounting_activity': 'Manuella konteringar är registrerade.',
  'onb.task.restMode.finding.other_bank_activity': 'Bankaktivitet utöver räntor och vanliga avgifter är registrerad.',
  'onb.task.restMode.finding.unsupported_scope': 'Land eller bolagsform stöds inte för viloläge.',
  'onb.task.restMode.finding.unknown': 'Ett annat kvalificeringsfynd kräver bedömning.',
  'onb.vat.period': 'Vilken momsperiod är verksamheten registrerad med?',
  'onb.vat.periodHelp': 'Välj perioden som är registrerad hos Skatteetaten.',
  'onb.vat.periodPick': 'Välj momsperiod',
  'onb.vat.periodRequired': 'Välj den momsperiod som verksamheten är registrerad med.',
  'onb.migration.step': 'Överföring',
  'onb.migration.title': 'Hur ska siffrorna flyttas till Plumme?',
  'onb.migration.help': 'Välj övergångstidpunkt och metod. Själva importen kan slutföras efter att företaget har skapats.',
  'onb.migration.yearStart': 'Övergång 1 januari',
  'onb.migration.yearStartHelp': 'Använd färdigt saldo från dagen innan som ingående balans.',
  'onb.migration.midYear': 'Övergång mitt i året',
  'onb.migration.midYearHelp': 'Ta med årets transaktioner, öppna poster och pågående momsperiod fram till övergångsdatumet.',
  'onb.migration.method': 'Överföringsmetod',
  'onb.migration.methodHelp': 'Fullständig import rekommenderas när filen finns. Allt kontrolleras före godkännande.',
  'onb.migration.pick': 'Välj metod',
  'onb.migration.complete': 'Fullständig import eller SAF-T (rekommenderas)',
  'onb.migration.balance': 'Importera råbalans / IB',
  'onb.migration.manual': 'Lägg in manuellt',
  'onb.migration.transitionRequired': 'Välj om övergången sker 1 januari eller mitt i året.',
  'onb.migration.methodRequired': 'Välj hur bokföringen ska överföras, eller gör det senare.',
  'onb.bank.step': 'Bankkonton',
  'onb.bank.title': 'Ställ in företagets bankkonton',
  'onb.bank.help': 'Bankkontona används för betalning, fakturor och avstämning. Bankintegration är ett separat tillägg och ingår inte i denna inställning.',
  'onb.bank.addNow': 'Lägg till bankkonton nu',
  'onb.bank.addNowHelp': 'Registrera konto, startsaldo och eventuella kort.',
  'onb.bank.none': 'Inget eget företagskonto',
  'onb.bank.noneHelp': 'Passar när företagets inköp betalas privat och ska registreras som utlägg.',
  'onb.bank.laterHelp': 'Uppgiften ligger kvar under Nästa steg.',
  'onb.bank.invoiceDefault': 'Använd det här kontot på fakturor',
  'onb.bank.cardsLater': 'Klargör kort senare',
  'onb.bank.addAnother': 'Lägg till ett bankkonto',
  'onb.bank.noConnection': 'Bankkoppling har tagits bort från grundinställningen. En eventuell bankintegration erbjuds separat som ett betalt tillägg.',
  'onb.bank.choiceRequired': 'Välj om bankkonton ska ställas in nu eller senare.',
  'onb.bank.accountRequired': 'Lägg till minst ett bankkonto.',
  'onb.bank.incomplete': 'Fyll i kontonummer, huvudbokskonto, startdatum och startsaldo för alla bankkonton.',
  'onb.bank.cardRequired': 'Ange kortets fyra sista siffror, bekräfta att kontot inte har kort, eller klargör kort senare.',
  'onb.bank.accountName': 'Kontots namn',
  'onb.bank.account': 'Bankkonto',
  'onb.bank.ledger': 'Konto i bokföringen',
  'onb.bank.startDate': 'Startdatum',
  'onb.bank.startBalance': 'Saldo på startdatum',
  'onb.invoice.step': 'Fakturainställning',
  'onb.invoice.title': 'Gör faktureringen redo',
  'onb.invoice.help': 'Nästa fakturanummer måste fortsätta en kontrollerbar nummerserie. Vid import bör numret kontrolleras mot tidigare fakturor.',
  'onb.invoice.now': 'Ställ in faktura nu',
  'onb.invoice.nowHelp': 'Välj nästa fakturanummer och vanlig betalningsfrist.',
  'onb.invoice.laterHelp': 'Inställningen måste slutföras innan den första fakturan kan utfärdas.',
  'onb.invoice.choiceRequired': 'Välj om fakturainställningen ska göras nu eller senare.',
  'onb.invoice.invalid': 'Nästa fakturanummer måste vara minst 1 och betalningsfristen mellan 1 och 365 dagar.',
  'onb.invoice.paymentDays': 'Vanlig betalningsfrist (dagar)',
  'onb.vehicle.step': 'Fordon',
  'onb.vehicle.title': 'Har verksamheten fordon eller bilkostnader?',
  'onb.vehicle.help': 'Svaret används för att följa upp rätt fordonsinställning. Det avgör inte momsavdrag på egen hand.',
  'onb.vehicle.business': 'Verksamheten äger eller leasar',
  'onb.vehicle.businessHelp': 'Fordonstyp, användning och avdragshantering klargörs i en separat inställning.',
  'onb.vehicle.private': 'Privat fordon används i verksamheten',
  'onb.vehicle.privateHelp': 'Plumme följer upp körjournal och privata utlägg.',
  'onb.vehicle.noneHelp': 'Ingen fordonsuppföljning skapas nu.',
  'onb.vehicle.laterHelp': 'Uppgiften visas igen vid behov.',
  'onb.vehicle.choiceRequired': 'Välj hur fordon ska följas upp, eller gör det senare.',
  'onb.review.step': 'Sammanfattning',
  'onb.review.title': 'Kontrollera inställningen',
  'onb.review.deferredHelp': 'Företaget kan skapas nu. Det du har skjutit upp ligger kvar synligt under Nästa steg.',
  'onb.review.readyHelp': 'Grundinställningen är klar. Du kan ändra uppgifterna senare i Inställningar.',
  'onb.followup.migration': 'Slutför överföringen från tidigare system',
  'onb.followup.bank': 'Ställ in bankkonton',
  'onb.followup.invoice': 'Slutför fakturainställningen',
  'onb.followup.vehicle': 'Klargör fordonsinställningen',
  'onb.task.eyebrow': 'Kom igång',
  'onb.task.title': 'Nästa steg för företaget',
  'onb.task.help': 'Uppgifterna försvinner automatiskt när inställningen är slutförd. Vissa uppgifter kan du också markera som slutförda själv. Obligatorisk kvalificering måste bekräftas av systemet.',
  'onb.task.remaining': '{{count}} uppgifter återstår',
  'onb.task.open': 'Öppna',
  'onb.task.complete': 'Slutförd',
  'onb.task.completeError': 'Det gick inte att markera uppgiften som slutförd.',
  'onb.task.showAll': 'Visa alla ({{count}})',
  'onb.task.showLess': 'Visa färre',
  'onb.task.vat.title': 'Välj registrerad momsperiod',
  'onb.task.vat.detail': 'Tidsfrister och MVA-meldinger kan inte planeras säkert förrän perioden är bekräftad.',
  'onb.task.migration.title': 'Slutför överföringen från tidigare system',
  'onb.task.migration.detail': 'Importera SAF-T, råbalans eller startsiffror och kontrollera underlaget.',
  'onb.task.bank.title': 'Konfigurera bankkonton',
  'onb.task.bank.detail': 'Registrera startdatum, startsaldo och eventuella kort före bankavstämning.',
  'onb.task.invoice.title': 'Slutför fakturainställningarna',
  'onb.task.invoice.detail': 'Kontrollera nästa fakturanummer och betalningsfrist före första fakturan.',
  'onb.task.vehicle.title': 'Klargör fordonsinställningarna',
  'onb.task.vehicle.detail': 'Välj rätt uppföljning innan fordonskostnader hanteras automatiskt.',
  'onb.task.master.title': 'Importera kunder, leverantörer och produkter',
  'onb.task.master.detail': 'Gör detta efter en fullständig bokföringsimport, så att du undviker dubbletter.',
  'onb.doneAlt': 'Plumme',
  'onb.bank.operatingName': 'Driftskonto',
  'onb.bank.currency': 'Valuta',
  'onb.assets.step': 'Tillgångar',
  'onb.assets.title': 'Finns det tillgångar i öppningsbalansen?',
  'onb.assets.help': 'Maskiner, inventarier, bilar och andra varaktiga anläggningstillgångar måste registreras var för sig efter att ingående balans eller import är på plats.',
  'onb.assets.yes': 'Ja, registrera efter överföringen',
  'onb.assets.yesHelp': 'Plumme skapar en uppgift och öppnar den befintliga registreringen från öppningsbalansen.',
  'onb.assets.noHelp': 'Inga tillgångar ska föras vidare från tidigare bokföring.',
  'onb.assets.laterHelp': 'Klargör detta efter att överföringen har kontrollerats.',
  'onb.assets.separateValues': 'Plumme skapar inte tillgångar från ett samlat kontosaldo. Dokumentera bokfört värde, skattemässigt värde och avskrivningsplan separat.',
  'onb.assets.choiceRequired': 'Välj om öppningsbalansen innehåller tillgångar, eller gör det senare.',
  'onb.followup.assets': 'Registrera tillgångar från öppningsbalansen',
  'onb.task.assets.title': 'Registrera tillgångar från öppningsbalansen',
  'onb.task.assets.detail': 'Skapa en dokumenterad tillgång i taget och stäm av totalen mot kontona i ingående balans.',
});
